import React from "react";
import { Link } from "react-router-dom";
import { PageTemplate } from "@components/pageTemplate/PageTemplate";

const NotFoundPage: React.FC = () => {
  return (
    <PageTemplate title="Page Not Found">
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "2rem",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <img
          src="/404-illustration.webp"
          alt="404 - Page Not Found Illustration"
          style={{
            maxWidth: "400px",
            height: "auto",
            objectFit: "contain",
          }}
        />

        <h1 css={{ fontSize: "2rem", fontWeight: "bold" }}>
          Oops! Page Not Found
        </h1>

        <p css={{ fontSize: "1.1rem", maxWidth: "600px" }}>
          We couldn&apos;t find the page you&apos;re looking for. It might have
          been moved, deleted, or never existed.
        </p>

        <Link
          to="/"
          css={{
            padding: "0.75rem 1.5rem",
            backgroundColor: "var(--primary-color)",
            color: "blue",
            borderRadius: "4px",
            textDecoration: "none",
            transition: "opacity 0.2s",
            "&:hover": {
              opacity: 0.9,
            },
          }}
        >
          Return Home
        </Link>
      </div>
    </PageTemplate>
  );
};

export default NotFoundPage;
